// eslint-disable-next-line no-restricted-imports
import { Print } from "@mui/icons-material";

export default function PrintIcon() {
  return <Print />;
}
